import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import dropdown from "../../assets/images/header-dropdown.png";
import {
  deleteNotification,
  notificationList,
  UnviewedNotificationList,
  ViewAllNotifications,
} from "../../redux/action/notification";
import { connect, useSelector, useDispatch } from "react-redux";
import dateFormat from "dateformat";
import { io } from "socket.io-client";
import { APIURL, SOCETCONNURL } from "../../redux/action/config";
import { toast } from "react-toastify";
import { getAdmin, logout } from "../../redux/action/auth";
// import NotificationSound from "./notification.mp3";
// import playAlert from "alert-sound-notify";
// import { BELL_DATA } from "../../redux/action/type";

const Header = (props) => {
  const id = localStorage.getItem("userId");
  const token = localStorage.getItem("token");

  const notifications = useSelector(
    (state) => state?.Notification?.unviewed?.data?.notification
  );
  const bellData = useSelector((state) => state?.Notification?.bell);
  const unClosedNotifications = useSelector(
    (state) => state?.Notification?.list?.data?.notification
  );
  const [notification, setNotification] = useState([]);
  const [unclosedNotification, setunclosedNotification] = useState([]);
  const [BELL, setBell] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(UnviewedNotificationList());
    dispatch(notificationList());
  }, [dispatch]);

  useEffect(() => {
    const socket = io(SOCETCONNURL);
    socket.on("unviewed-notification-list", (items) => {
      setNotification(items);
      // dispatch({
      //   type: BELL_DATA,
      //   payload: items,
      // });
      // setTimeout(() => {
      //   setBell(items);
      // }, 1000);
      // playAlert("glass");
    });
    socket.on("unClosed-notification-list", (items) => {
      setunclosedNotification(items);
      // playAlert("glass");
    });
  }, [dispatch]);

  const viewAll = () => {
    dispatch(ViewAllNotifications());
  };

  const [disableButton, setDisableButton] = useState(false)
  const removeNotification = (id) => {
    setDisableButton(true)
    dispatch(deleteNotification(id, (res) => {
      if (res === 'success') {
        toast.success("Notifications removed sucessfully!");
        setTimeout(() => {
          setDisableButton(false)
        }, 1500);
      }
    }));
    setTimeout(() => {
      dispatch(notificationList());
    }, 1000);
  };

  const truncate = (input) => {
    if (input?.length > 12) {
      return input?.substring(0, 2) + ".";
    }
    return input;
  };

  useEffect(() => {
    var backdrop = document.querySelector(".backdrop");
    var toggleButton = document.querySelector(".toggle-container");
    var mobileNav = document.querySelector(".mobile-nav");

    backdrop.addEventListener("click", function () {
      mobileNav.classList.remove("open");
      backdrop.classList.remove("open");
      toggleButton.classList.remove("active", "change");
    });

    toggleButton.addEventListener("click", function () {
      mobileNav.classList.add("open");
      toggleButton.classList.add("active", "change");
      backdrop.classList.add("open");
    });
  }, []);

  // LOGOUT IF USER IS NOT AUTHORIZED

  useEffect(() => {
    const authorizeAdmin = async () => {
      await getAdmin()
    }
    authorizeAdmin()
  }, []);

  return (
    <React.Fragment>
      <div id="kt_header" className="header align-items-stretch d-print-none">
        <div className="header-brand">
          <Link to="/dashboard">
            <img alt="Logo" src={logo} className="logo" />
          </Link>
          <div
            className="d-flex align-items-center d-lg-none ms-n3 me-1"
            title="Show aside menu"
          >
            <div className="backdrop"></div>
            <div className="btn btn-icon btn-active-color-primary w-30px h-30px toggle-container">
              <span className="svg-icon svg-icon-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                    fill="black"
                  />
                  <path
                    opacity="0.3"
                    d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                    fill="black"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div className="topbar">
          <div className="container-fluid py-6 py-lg-0 d-flex flex-column flex-sm-row align-items-lg-stretch justify-content-sm-between">
            <div className="page-title d-flex flex-column me-5">
              <h1 className="d-flex flex-column text-dark fw-bolder fs-2 mb-0">
                {props.title}
              </h1>
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 pt-1">
                <li className="breadcrumb-item text-muted">
                  <Link
                    to="/dashboard"
                    className="text-muted text-hover-primary"
                  >
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-300 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-dark">{props.title}</li>
              </ul>
            </div>

            <div className="d-flex align-items-center pt-3 pt-sm-0">
              <div className="d-flex">
                <div className="d-flex align-items-center me-4">
                  <div
                    className="btn btn-icon btn-active-light btn-outline btn-outline-default btn-icon-gray-700 btn-active-icon-primary"
                    data-kt-menu-trigger="click"
                    data-kt-menu-attach="parent"
                    data-kt-menu-placement="bottom-end"
                    data-kt-menu-flip="bottom"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="svg-icon svg-icon-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="2"
                          width="9"
                          height="9"
                          rx="2"
                          fill="black"
                        />
                        <rect
                          opacity="0.3"
                          x="13"
                          y="2"
                          width="9"
                          height="9"
                          rx="2"
                          fill="black"
                        />
                        <rect
                          opacity="0.3"
                          x="13"
                          y="13"
                          width="9"
                          height="9"
                          rx="2"
                          fill="black"
                        />
                        <rect
                          opacity="0.3"
                          x="2"
                          y="13"
                          width="9"
                          height="9"
                          rx="2"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </div>
                  <div
                    className="menu menu-sub menu-sub-dropdown menu-column w-250px w-lg-325px dropdown-menu"
                    data-kt-menu="true"
                  >
                    <div
                      className="d-flex flex-column flex-center bgi-no-repeat rounded-top px-9 py-10"
                      style={{
                        backgroundImage: `url(${dropdown})`,
                      }}
                    >
                      <h3 className="text-white fw-bold mb-3">Quick Links</h3>
                      {/* <span className="badge bg-primary py-2 px-3">
                        25 pending tasks
                      </span> */}
                    </div>
                    <div className="row g-0">
                      <div className="col-6">
                        <Link
                          to="/add-fleet"
                          className="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end border-bottom"
                        >
                          <span className="svg-icon svg-icon-3x svg-icon-primary mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-gear"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                              <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
                            </svg>
                          </span>
                          <span className="fs-5 fw-bold text-gray-800 mb-0">
                            Add Fleet
                          </span>
                        </Link>
                      </div>
                      <div className="col-6">
                        <Link
                          to="/manage-service"
                          className="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-bottom"
                        >
                          <span className="svg-icon svg-icon-3x svg-icon-primary mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-truck"
                              viewBox="0 0 16 16"
                            >
                              <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                            </svg>
                          </span>
                          <span className="fs-5 fw-bold text-gray-800 mb-0">
                            Services
                          </span>
                        </Link>
                      </div>
                      <div className="col-6">
                        <Link
                          to="/manage-staff"
                          className="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end"
                        >
                          <span className="svg-icon svg-icon-3x svg-icon-primary mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-people"
                              viewBox="0 0 16 16"
                            >
                              <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
                            </svg>
                          </span>
                          <span className="fs-5 fw-bold text-gray-800 mb-0">
                            Staff
                          </span>
                        </Link>
                      </div>
                      <div className="col-6">
                        <Link
                          to={`/profile/${id}`}
                          className="d-flex flex-column flex-center h-100 p-6 bg-hover-light"
                        >
                          <span className="svg-icon svg-icon-3x svg-icon-primary mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-person"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                            </svg>
                          </span>
                          <span className="fs-5 fw-bold text-gray-800 mb-0">
                            Profile
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-center position-relative">
                  {/* {console.log(notification, "notification")} */}
                  <div className="notification-bar rounded-circle">
                    {notification?.length
                      ? truncate(notification?.length?.toString())
                      : 0}
                  </div>
                  <div
                    type="button"
                    className={`btn btn-icon btn-primary fw-bolder ${truncate(notification?.length?.toString()) > 0
                      ? ""
                      : "btn-bell"
                      }`}
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    onClick={viewAll}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-bell-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z" />
                    </svg>
                  </div>
                  <div
                    className="modal-in-header modal fade right-0"
                    id="staticBackdrop"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div
                          className="modal-header"
                          style={{
                            backgroundImage: `url(${dropdown})`,
                            position: "relative",
                          }}
                        >
                          <h3
                            className="modal-title text-white fw-bold px-9 mt-6 mb-10"
                            id="staticBackdropLabel"
                          >
                            Notifications
                          </h3>
                          <div className="rounded bg-white">
                            <button
                              type="button"
                              className="btn-close m-0"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <ul
                            className="nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9 position-absolute"
                            style={{ bottom: "-2px", left: "0px" }}
                          >
                            <li className="nav-item">
                              <a
                                className="nav-link text-white opacity-75 opacity-state-100 pb-4 active"
                                data-bs-toggle="tab"
                                href="#kt_topbar_notifications_1"
                              >
                                Alerts
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="modal-body">
                          <div className="scroll-y mh-325px my-5 px-8">
                            {unclosedNotification?.length
                              ? unclosedNotification?.map((item, i) => {
                                return (
                                  <div key={i} className="d-flex flex-stack py-4">
                                    <a
                                      href={
                                        item.type == "order"
                                          ? `/edit-order/${item.id}`
                                          : item.type == "customer"
                                            ? `/edit-customers/${item.id}`
                                            : `/edit-staff/${item.id}`
                                      }
                                      aria-label="Close"
                                    >
                                      <div className="d-flex align-items-center">
                                        <div className="symbol symbol-35px me-4">
                                          <span className="symbol-label bg-light-warning">
                                            <span className="svg-icon svg-icon-2 svg-icon-warning">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                              >
                                                <path
                                                  opacity="0.3"
                                                  d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z"
                                                  fill="black"
                                                />
                                                <path
                                                  d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z"
                                                  fill="black"
                                                />
                                              </svg>
                                            </span>
                                          </span>
                                        </div>
                                        <div className="mb-0 me-2">
                                          <Link
                                            to="#"
                                            className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                                          ></Link>
                                          <div
                                            className="text-gray-400 fs-7"
                                            style={{
                                              fontWeight: "bold",
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {`${item?.type}`}
                                          </div>
                                          <div className="text-gray-400 fs-7">
                                            {`
                                              ${item.description} on
                                              ${dateFormat(
                                              item.createdAt,
                                              "d mmmm , yyyy"
                                            )}`}
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                    <span className="badge badge-light fs-8">
                                      at{" "}
                                      {dateFormat(
                                        item.createdAt,
                                        " h:MM:ss TT"
                                      )}
                                    </span>
                                    <button
                                      disabled={!disableButton ? false : true}
                                      className="close rounded-circle"
                                      onClick={() => {
                                        removeNotification(item._id);
                                      }}
                                    >
                                      x
                                    </button>
                                  </div>
                                );
                              })
                              : "No Data Found"}
                          </div>
                          <div className="py-3 text-center border-top">
                            <a
                              href="/view-notifications"
                              className="btn btn-color-gray-600 btn-active-color-primary"
                            >
                              View All
                              <span className="svg-icon svg-icon-5">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <rect
                                    opacity="0.5"
                                    x="18"
                                    y="13"
                                    width="13"
                                    height="2"
                                    rx="1"
                                    transform="rotate(-180 18 13)"
                                    fill="black"
                                  />
                                  <path
                                    d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
Header.defaultProps = {
  title: "Dashboard",
};
export default Header;
